import Modal from "../common/Modal";

const CallModal = ({ open, onClose }) => {

    return (
        <Modal open={open} title="Contact Us" onClose={onClose}>

            <div className="call-options">

                <div className="call-card">
                    💬 Chat Now
                </div>

                <div className="call-card">
                    📞 Call Harsh BSB
                </div>

            </div>

        </Modal>
    );
};

export default CallModal;